import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "_flex gfu-hd--h6 _gap-1 _tc--accent" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_user_follow = _resolveComponent("user-follow")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: $props.author.profileUrl,
      "data-qa": "project-comment-action:ViewProfileLink"
    }, _toDisplayString(_ctx.Resources.Profile.ViewProfileAction), 9 /* TEXT, PROPS */, _hoisted_2),
    ($options.hasFollowAction)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gfu-comment-user-profile-actions-separator" }, null, -1 /* CACHED */)),
          _createVNode(_component_user_follow, {
            "user-url-name": $props.author.urlName,
            nickname: $props.author.nickname,
            "user-id": $props.author.userID
          }, {
            default: _withCtx(({ isFollowing, onFollow, onUnfollow }) => [
              isFollowing
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "_ttl",
                    onClick: _withModifiers(onUnfollow, ["prevent"]),
                    "data-qa": "project-comment-action:UnfollowLink"
                  }, _toDisplayString(_ctx.Resources.Profile.UserUnfollowAction), 9 /* TEXT, PROPS */, _hoisted_3))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "#",
                    class: "_ttl",
                    onClick: _withModifiers(onFollow, ["prevent"]),
                    "data-qa": "project-comment-action:FollowLink"
                  }, _toDisplayString(_ctx.Resources.Profile.UserFollowAction), 9 /* TEXT, PROPS */, _hoisted_4))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["user-url-name", "nickname", "user-id"])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}